var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKonuVideolari = function SvgKonuVideolari(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.14 267.011L242.807 181.178C260.015 171.243 265.911 149.239 255.976 132.031C246.041 114.823 224.037 108.927 206.828 118.862L58.1617 204.695C40.9535 214.63 35.0575 236.634 44.9927 253.842C54.9278 271.05 76.9318 276.946 94.14 267.011Z",
    fill: "url(#paint0_linear_4330_4137)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.17 235.833L112.17 64.1678C112.17 44.2975 96.0619 28.1895 76.1916 28.1895C56.3213 28.1895 40.2133 44.2975 40.2133 64.1678L40.2133 235.833C40.2133 255.704 56.3213 271.812 76.1916 271.812C96.0619 271.812 112.17 255.704 112.17 235.833Z",
    fill: "url(#paint1_linear_4330_4137)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M242.803 118.822L94.1367 32.9892C76.9285 23.054 54.9245 28.95 44.9894 46.1581C35.0542 63.3663 40.9502 85.3703 58.1583 95.3054L206.825 181.138C224.033 191.073 246.037 185.177 255.972 167.969C265.907 150.761 260.012 128.757 242.803 118.822Z",
    fill: "url(#paint2_linear_4330_4137)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224.859 186.166C244.776 186.166 260.922 170.02 260.922 150.103C260.922 130.185 244.776 114.039 224.859 114.039C204.941 114.039 188.795 130.185 188.795 150.103C188.795 170.02 204.941 186.166 224.859 186.166Z",
    fill: "#2B81FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4330_4137",
    x1: 63.0169,
    y1: 284.976,
    x2: 30.6983,
    y2: 150.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4330_4137",
    x1: 112.167,
    y1: 271.769,
    x2: -20.1726,
    y2: 232.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4330_4137",
    x1: 273.923,
    y1: 136.793,
    x2: 173.903,
    y2: 231.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0226A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2B81FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#86B8FD"
  })))));
};
export default SvgKonuVideolari;